import React, { useEffect, useState } from 'react';
import AuthSidebarSignIn from './AuthSidebarSignIn';
import AuthSidebarSignUp from './AuthSidebarSignUp';
import IconClose from '../UI/Icons/IconClose';
import { STATIC_PREFIX } from '../../constants/staticPrefix';

const AuthSidebar = ({ isSidebar, toggleSidebar }) => {
  const [isSignIn, toggleSignIn] = useState(true);
  const [isAnimated, setAnimated] = useState(false);

  const closeAuthSidebar = () => toggleSidebar(false);

  useEffect(() => {
    setAnimated(true);
  }, []);

  return (
    <div className={`auth-sidebar ${isSidebar ? 'visible' : ''} ${isAnimated ? 'animated' : ''}`}>
      <div className="auth-sidebar__content">
        <div
          className="auth-sidebar__close-sidebar"
          onClick={closeAuthSidebar}
        >
          <IconClose color="#c7c6cc" />
        </div>
        <img
          className="auth-sidebar__content__logo"
          src={`${STATIC_PREFIX}/static/images/logo.svg`}
          alt="Bit team logo"
        />
        {
          isSignIn
            ? (
              <AuthSidebarSignIn
                toggleSidebar={toggleSignIn}
                closeAuthSidebar={closeAuthSidebar}
              />
            )
            : (
              <AuthSidebarSignUp
                toggleSidebar={toggleSignIn}
                closeAuthSidebar={closeAuthSidebar}
              />
            )
        }
      </div>
      <div
        className="auth-sidebar__underlay"
        onClick={() => closeAuthSidebar()}
      />
    </div>
  );
};

export default AuthSidebar;
